import get from 'lodash/get'
import templite from 'templite'
import { useCallback } from 'react'
import { useAppContext }  from './AppContext';

export const useTranslation = () => {
  const { langDictionary } = useAppContext()

  const t = useCallback(
    (key: any, params: Record<string, any> = {}) => {
      if (typeof key === 'string') {
        const value = get(langDictionary, key)
        return value ? templite(value, params) : key
      }
      return ''
    },
    [langDictionary]
  )

  return t
}
